import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";

// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      userToDeleteId: null,
      active: true,
      categoryData: null,
      id: null,
      showreject: false,
      search_event: "",
      data: null,
    };
  }

  componentDidMount() {
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/setting/category`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          this.setState({
            categoryData: res.data.data,
            data: res.data.data,
          });
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Category Name",
        accessor: "name",
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              <Tooltip title="View">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let id = props.original._id;
                    this.props.history.push(`/admin/viewCategory/${id}`);
                  }}
                >
                  <Icon>visibility</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let id = props.original._id;
                    // this.setState({
                    //   showreject: true,
                    //   id,
                    // });
                    this.props.history.push(`/admin/editCategory/${id}`);
                    // "/admin/viewCategory/"
                  }}
                >
                  <Icon>edit</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let id = props.original._id;
                    this.setState({
                      showreject: true,
                      id,
                    });
                  }}
                >
                  <Icon>delete</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    const {
      showWarning,
      data,
      search_event,
      userToDeleteId,
      categoryData,
      showreject,
    } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                <TextField
                  id="standard-search"
                  label="Search Category by name"
                  name="search_event"
                  type="search"
                  fullWidth
                  value={search_event}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState(
                      {
                        categoryData: data,
                      },
                      () => {
                        const newwebinarData = this.state.categoryData.filter(
                          (item) =>
                            item.name
                              .toLowerCase()
                              .includes(value.toLowerCase())
                        );
                        this.setState({
                          categoryData: newwebinarData,
                          search_event: value.toLowerCase(),
                        });
                      }
                    );
                  }}
                  margin="normal"
                />
                <ReactTable
                  data={categoryData ? categoryData : []}
                  columns={this.getUserTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Customers found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to delete this category?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            let id = this.state.id;
            // let body = {
            //   id: id
            // };
            axios
              .delete(`${domain}/setting/category/${id}`, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("Category Deleted Successfully!");
                  this.setState({
                    showreject: false,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                } else {
                  toastr.error(res.data.message);
                }
              })
              .catch((error) => {});
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
